import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';
import { Practice } from '../models/practice';
import { Programme } from '../models/programme';

@Injectable({
  providedIn: 'root'
})
export class PracticeService {

  constructor(
    private _http:HttpClient
  ) { }

  public notifyMembers(programmeId:number):Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/programme/notifyMembers', {programmeId:programmeId}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getSeatLog(pid):Observable<any>{
    return this._http.get(environment.apiEndpoint+`/api/admin/practice/${pid}/seatlog`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getPaginatedPractices(page, pp, filters): Observable<iHttpPaginatedResponse> {
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/practices?page=${page}&pp=${pp}&${filters}`).pipe(
        map(res => {
            return res;
        })
    );
  }

  public getPaginatedBacsRenewals(page, pp, filters): Observable<iHttpPaginatedResponse> {
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/practicesBacsRenewals?page=${page}&pp=${pp}&${filters}`).pipe(
        map(res => {
            return res;
        })
    );
  }

  public getPaginatedPracticesAdmin(page, pp, filters): Observable<iHttpPaginatedResponse> {
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/practices?page=${page}&pp=${pp}${filters}`).pipe(
        map(res => {
            return res;
        })
    );
  }

  public getPractice(practiceId:number):Observable<Practice>{
    return this._http.get<Practice>(environment.apiEndpoint + '/api/admin/practice/' + practiceId).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public createPracticeProgramme(id:number, name:string): Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/admin/practice/'+id+'/programme', {name:name}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getPracticeProgrammes(id:number): Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/admin/practice/'+id+'/programmes').pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getProgramme(id:number): Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/admin/programme/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public updatePracticeProgramme(programme:Programme): Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/programme/'+programme.id, {programme:programme}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public removePracticementor(practiceId:number, mentorId:number):Observable<any>{
    return this._http.delete(environment.apiEndpoint+'/api/removePracticeMentor/'+practiceId+'/'+mentorId).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public invitePracticeMentor(practiceId:number, mentorEmail:string):Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/invitePracticeMentor', {practiceId:practiceId, mentorEmail:mentorEmail}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public reinvitePracticeMentor(inviteId:number):Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/reinvitePracticeMentor', {inviteId:inviteId}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public cancelPracticeMentorInvite(inviteId:number):Observable<any>{
    return this._http.delete(environment.apiEndpoint+'/api/cancelPracticeMentorInvite/'+inviteId).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public updatePractice(practice:Practice): Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/practice/details/'+practice.id, {practice:practice}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getPracticeContent(id:number): Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/admin/practice/'+id+'/content').pipe(
      res=>{
        return res;
      }
    );
  }

  public createPracticeContent(id:number): Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/admin/practice/'+id+'/content', {name: 'New Practice Course'}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public inviteUser(practiceId:number, userEmail:string): Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/admin/practice/'+practiceId+'/invite', {email:userEmail}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public revokeInvite(practiceId:number, memberId:number): Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/admin/practice/'+practiceId+'/revokeInvite', {memberId:memberId}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public reinvitePracticeMember(inviteId:number):Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/reinvitePracticeMember', {inviteId:inviteId}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public removeUser(memberId:number):Observable<any>{
    return this._http.delete(environment.apiEndpoint+`/api/admin/practice/member/${memberId}`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public toggleUser(memberId:number):Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/practice/toggleMember', {memberId:memberId}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public registerInviteMember(email:string, first_name:string, last_name:string, role:string, practice_id:number):Observable<any>{
    return this._http.post(environment.apiEndpoint+`/api/practice/registerInviteMemberAdmin`,{email:email, first_name:first_name, last_name:last_name, role:role, practice_id:practice_id}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
